import { render, staticRenderFns } from "./StepsUI.vue?vue&type=template&id=3f499a96&scoped=true"
import script from "./StepsUI.vue?vue&type=script&lang=js"
export * from "./StepsUI.vue?vue&type=script&lang=js"
import style0 from "./StepsUI.vue?vue&type=style&index=0&id=3f499a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f499a96",
  null
  
)

export default component.exports